<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base">
      <admin-menu/>
    </div>
  </div>
</template>

<script>
import AdminMenu from './../components/AdminMenu.vue'

export default {
  components: {
    AdminMenu
  }
};
</script>